const str = `{HEADER}プライバシーポリシー

{BODY_TITLE}1.収集する個人情報の項目及び収集方法
A.収集する個人情報の項目
第一、当社は会員登録、円滑なお問い合わせ、各種のサービス提供のために最初の会員登録の際、利用者から以下の個人情報を収集しています。
{ADD_LINE}
会員登録：氏名、Eメールアドレス、一方向ハッシュ暗号化されたパスワード
Facebookでログインする場合：Facebook ID及びFacebookが提供する情報(公開プロフィール、Eメールアドレス、生年月日、写真及び動画などを含みます)
NAVERでログインする場合：NAVER ID及びFacebookが提供する情報(公開プロフィール、Eメールアドレス、生年月日、写真及び動画などを含みます)　Googleでログインする場合：Google ID及びFacebookが提供する情報(公開プロフィール、Eメールアドレス、生年月日、写真及び動画などを含みます)
{ADD_LINE}
第二、サービスの利用過程または事業処理過程で以下の情報が自動で生成され収集されることがあります。
貴下のIPアドレス、ブラウザタイプ、運営システム、当社のウェブサイトを訪問する間にクリックしたリンク、訪問した特定のウェブページ、位置、インタネットサービス
提供者の氏名、当社のウェブサイトへリンクしてきたウェブページ、訪問日時及び時間、当社のウェブサイトから移動したウェブページなど
{ADD_LINE}
第三、付加サービス及びカスタマイズサービスの利用またはイベント応募過程で該当サービスの利用者に限って以下の情報が収集されることがあります。
個人情報の追加収集について同意を得る場合
{ADD_LINE}
第四、有料サービスの利用過程で以下の決済情報が収集されることがあります。
クレジットカード決済時：トークン
{ADD_LINE}
銀行振込時：銀行名、口座番号など
商品券利用時：商品券番号
{ADD_LINE}
B.個人情報の収集方法
当社は以下のような方法で個人情報を収集します。
ホームページ、書面フォーム、FAX、電話、掲示板、Eメールアドレス、イベント応募、配送要請
協力会社からの提供
生成情報の収集ツールによる収集

{BODY_TITLE}2.個人情報の収集及び利用目的
A.サービス提供に関する契約履行及びサービス提供による料金精算
コンテンツ提供、カスタマイズサービスの提供、物品配送または請求書などの発送、本人認証、購入及び料金決済、料金の取り立て
B.会員管理
会員制サービス提供、個人識別、利用規約を違反した会員に対する利用制限措置、サービスの円滑な運営に支障を及ぼす行為とサービス不正利用行為制裁、登録意思の確認、登録及び登録回数の制限、紛争調整のための記録保存、不満処理などの苦情処理、告知事項伝達、退会意思の確認
C.新規サービスの開発及びマーケティング･広告への活用
新規サービスの開発及びカスタマイズサービスの提供、統計学的特性に応じたサービスの提供と広告掲載、サービスの有効性を確認、イベント情報及び参加の機会を提供、広告性情報の提供、アクセス頻度の把握、会員のサービス利用に関する統計

{BODY_TITLE}3.個人情報の共有及び提供
当社は、利用者の個人情報を「2.個人情報の収集及び利用目的」で告知した範囲内で利用します。また、事前にご本人の同意を得ることなく同範囲を超えて利用したり、原則的に利用者の個人情報を外部に公開しません。但し、以下の場合は例外とみなします。
A.ビデオモンスター連携サービスについて利用者が事前に同意した場合
B.法令の規定に基づき、または、捜査目的で法令に定められた手続きと方法により捜査機関の要請がある場合

{BODY_TITLE}4.個人情報の取扱いの委託
当社は、サービス向上のために以下のように個人情報を委託しています。関係法令に基づいて委託契約の際、個人情報が安全に管理できるよう必要な事項を規定しています。
当社の個人情報委託処理機関及び委託業務内容は以下のとおりです。
{ADD_LINE}
受託企業
委託業務内容
個人情報の保有及び利用期間
{ADD_LINE}
Google
利用データ分析
(Google Analytics)及びデータ保存(Google Cloud Platform)
{ADD_LINE}
Microsoft Azure
データ保存
(Microsoft Cloud Services)
{ADD_LINE}
MailChimp
Eメールを通したコミュニケーションサポート
{ADD_LINE}
Facebook
個人化された顧客体験サポート
{ADD_LINE}
Salesforce
データ保存･顧客相談サポート
{ADD_LINE}
INICIS
決済データ保存
{ADD_LINE}
Zencoder
利用者がアップデートした動画ファイルを変換

{BODY_TITLE}5.個人情報の保有及び利用期間
利用者の個人情報は、原則として個人情報の収集及び利用目的が達成されると、直ちに破棄します。但し、以下の情報については下記の保存理由より記述した期間内に保存します。
{ADD_LINE}
A.当社の内部方針による情報保有の事由
不正利用履歴(不正登録、懲戒履歴などの非正常的なサービスの利用履歴)
{ADD_LINE}
保存項目：登録認証の携帯電話
保存理由：不正登録及び利用防止
保存期間：2年
※ 「不正利用履歴」とは不正登録及び運営原則に違反する掲示物などで当社より利用制限などを受けた履歴です。
{ADD_LINE}
B.関連法令による情報保有の事由
商法、電子商取引などで消費者保護に関する法律など、関係法令の規定に基づいて保存する必要がある場合、当社は関係法令が規定した一定期間、会員情報を保存します。この場合、当社は保存する情報をその保存の目的でのみ利用し、保存期間は以下のとおりです。
{ADD_LINE}
契約またはクーリング・オフなどに関する記録
保存理由：電子商取引などでの消費者保護に関する法律
保存期間：5年
{ADD_LINE}
代金決済及び財貨などの供給に関する記録
保存理由：電子商取引などでの消費者保護に関する法律
保存期間：5年
{ADD_LINE}
電子金融取引に関する記録
保存理由：電子金融取引法
保存期間：5年
{ADD_LINE}
消費者の苦情、又は紛争処理に関する記録
保存理由：電子商取引などでの消費者保護に関する法律
保存期間：3年
{ADD_LINE}
ウェブサイトの訪問履歴
保存理由：通信秘密保護法
保存期間：3ヶ月

{BODY_TITLE}6.個人情報の破棄手順及び方法
利用者の個人情報は、原則として個人情報の収集及び利用目的が達成されると、直ちに破棄します。
当社の個人情報破棄手順及び方法は以下のとおりです。
{ADD_LINE}
A.破棄手順
利用者が会員登録などのために入力した情報は、目的が達成された後、別のDBに移され(紙の場合、別途の書類箱)、内部の方針及びその他関係法令による情報保護の事由により(保有及び利用期間)
参照)一定の期間保存した後、破棄します。
同個人情報は、法律による場合ではない限り、保有以外の他の目的として利用しません。
{ADD_LINE}
B.破棄方法
紙に印刷された個人情報は、シュレッダーで粉砕、または焼却により破棄されます。
電子ファイル形式で保存された個人情報は、記録を再生できない技術的方法を利用し削除されます。

{BODY_TITLE}7.利用者の権利とその行使方法
利用者は、登録されている利用者本人の個人情報を、いつでも閲覧、訂正することができます。また、当社の個人情報処理に同意しない場合には、同意を拒否または登録解約(退会)を要請することができます。但し、そのような場合には、サービスの一部または全部の利用を制限されることがあります。
{ADD_LINE}
退会のメニューがない場合
利用者の個人情報の閲覧は「アカウント設定」をクリックして確認できます。個人情報の訂正と登録解約(同意撤回)を望む場合、個人情報管理責任者への書面またはEメールにてお問い合わせください。直ちに措置します。
{ADD_LINE}
退会のメニューがある場合
利用者の個人情報の閲覧は「アカウント設定」をクリックして確認できます。個人情報の訂正を望む場合、個人情報管理責任者に書面またはEメールにてお問い合わせください。直ちに措置します。また、登録解約(同意撤回)のためには「退会」をクリックして、本人確認の手続き後、直接退会できます。
{ADD_LINE}
当社は、利用者の要請により解約または削除された個人情報は、｢5.個人情報の保有及び利用期間｣に明示しているところにより処理し、それ以外の用途として閲覧または利用できないよう処理しています。

{BODY_TITLE}8.個人情報の自動収集装置の設置、運営及びその拒否に関する事項
A.クッキーとは?
当社は、個人化され、カスタマイズされたサービスを提供するために利用者の情報を保存し、随時に呼び込む「クッキー(cookie)」を利用します。
クッキーとは､ウェブサイトを運営するために利用されるサーバーが利用者のブラウザに送る小さいテキストファイルのことで、利用者のパソコンのハードディスクに保存されます。以後、利用者がウェブサイトに訪問する場合、ウェブサイトのサーバーは、利用者のハードディスクに保存されているクッキーの内容を読み取り、利用者の環境設定を維持し、カスタマイズされたサービスを提供するために利用します。
クッキーは、個人を識別するための情報を自動･能動的に収集しません。利用者はいつでも、クッキーの保存を拒否、または削除することができます。
{ADD_LINE}
B.当社のクッキーの利用目的
利用者が訪問したビデオモンスターの各サービスとウェブサイト訪問履歴及び利用タイプ、保安アクセス可否、利用者規模などを把握し、広告などの最適化されたカスタマイズ情報を提供するために活用します。
{ADD_LINE}
C.クッキーの受け入れ･運営及び拒否
利用者は、クッキーの受け入れに対する選択権を有しています。従って、ウェブブラウザの設定を変更することにより、すべてのクッキーを有効、またはクッキーを保存する際にメッセージを表示、あるいはすべてのクッキーを無効にすることもできます。
但し、クッキーを無効にする場合には、ログインを必要とする一部サービスの利用が制限されることがあります。
クッキーの処理方法(Internet Explorerの場合)は以下のとおりです。
①「ツール」メニューより「インターネットオプション」を選択します。
②「プライバシー」タブをクリックします。
③「詳細設定」からクッキーの処理方法をご希望通りに設定します。

{BODY_TITLE}9.個人情報保護の技術及び管理に関する対策
当社は、利用者の個人情報の取り扱いにおいて、個人情報が紛失、盗難、漏えい、変造、または毀損されないよう安全性確保のため、次のような技術･管理的対策を講じています。
{ADD_LINE}
A.パスワードの暗号化
ビデオモンスター会員のパスワードは暗号化され管理及び保存しているため、ご本人のみ知っています。個人情報の変更もパスワードを知っているご本人のみ可能です。
{ADD_LINE}
B.ハッキングなどに備えた対策
当社はハッキングやコンピュータウイルスなどによる個人情報の流出や毀損を防ぐために最善を尽くしています。
個人情報の毀損に備えて資料を随時バックアップし、最新のワクチンプログラムを利用して利用者の個人情報、資料の流出･損傷を防止しています。暗号化通信などを通してネットワーク上で個人情報を安全に送信できるようにしています。その他、システム的にセキュリティを確保するため、できる限りのあらゆる技術的装置を備えるために努めています。
{ADD_LINE}
C.取扱い担当従業員の最小化と教育
当社の個人情報関連を取り扱う従業員は担当者に限定しています。また、業務のための別途のパスワードを与え、定期的に更新しています。なお、担当者への随時教育を行いビデオモンスターの個人情報処理針の遵守を常に強調しています。

{BODY_TITLE}10.個人情報管理責任者及び担当者の連絡先
貴下は当社のサービスを利用する際に発生するすべての個人情報保護関連苦情を個人情報管理の責任者または担当部まで申し出ることができます。
当社は利用者の申出事項について速やかに十分なお答えを差し上げます。
{ADD_LINE}
個人情報管理責任者
氏名：ジョン・ドンヒョク
担当部署：情報保護チーム
電話番号：+82-2-554-6801
職位：代表取締役
Eメール：hello@videomonster.co.kr
{ADD_LINE}
個人情報管理担当者
氏名：ソン・シウ
担当部署：個人情報保護チーム
電話番号：+82-2-554-6801
職位：技術責任者
Eメール：hello@videomonster.com
{ADD_LINE}
その他の個人情報侵害に対するお申出やご相談は、以下の機関にお問い合わせ下さい。
個人情報侵害の申告センター (privacy.kisa.or.kr / 国番号なし118)
大検察庁サイバー捜査課 (www.spo.go.kr / 国番号なし 1301)
警察庁サイバー安全局 (www.ctrc.go.kr /国番号なし182)

{BODY_TITLE}11.その他
ビデオモンスターにリンクされているウェブサイトが個人情報を収集する行為に対しては、本「ビデオモンスターの個人情報処理方針」が適用されません。

{BODY_TITLE}12.告知の義務
現在の個人情報処理方針に内容追加、削除及び変更がある場合、改定より最低7日前にホームページにてお知らせします。但し、個人情報の収集及び利用、第3者への提供など、利用者権利の重大な変更が発生する場合は、最低30日前にお知らせします。

{FOOTER}
{FOOTER_SUB}この規約は、2019年5月1日より適用されます。
`

export default str